import {useSidebarPageLayoutActions} from '@github-ui/layout-primitives/SidebarPageLayout'
import {useEffect, useRef, type ReactNode} from 'react'

interface CollapseSidebarOnContentChangeProps {
  /**
   * Stable identifier for what the main content pane is currently showing.
   */
  contentKey: string
  /**
   * Render prop receiving the layout's `closeDialog` action so children (e.g. the
   * sidebar's new-session button) can dismiss the narrow-viewport dialog even when
   * `contentKey` doesn't change.
   */
  children: (actions: {closeDialog: () => void}) => ReactNode
}

export function CollapseSidebarOnContentChange({contentKey, children}: CollapseSidebarOnContentChangeProps) {
  const {closeDialog} = useSidebarPageLayoutActions()
  const previousKeyRef = useRef(contentKey)

  useEffect(() => {
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- reacting to external route state, not an in-component event
    if (previousKeyRef.current !== contentKey) {
      previousKeyRef.current = contentKey
      closeDialog()
    }
  }, [contentKey, closeDialog])

  return children({closeDialog})
}
